"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flash24hrTime = void 0;
var convert_1 = require("../convert/convert");
// Used for quickly switching an input from 12hr to 24hr then back to 12hr.
// This is useful when the user submits forms.
// It will sends 24hr time to the server on submit like modern browsers do.
// Not adding a form event listener, different frameworks might handle submit differently
exports.flash24hrTime = function ($input) {
    var value12hr = $input.value;
    $input.value = convert_1.convertString12hr(value12hr).to24hr();
    setTimeout(function () {
        $input.value = value12hr;
    }, 1);
};
